import { helper } from '@ember/component/helper';

export const stringContains = (params) => {
  const str = params[0] || '';
  const substr = params[1] || '';
  return str.indexOf(substr) !== -1;
};

export default helper(stringContains);
